<template>
  <div class="chat-history-page">
    <section class="side-sessions">
      <div class="side-sessions--search">
        <v-text-field
          v-model="search"
          ref="search"
          outline
          hide-details
          placeholder="Search sessions..."
          prepend-inner-icon="search"
          height="40px"
        ></v-text-field>


        <v-btn width="50px" outline class="filter-trigger" @click="dialog=true">
          <v-icon>filter_alt</v-icon>
        </v-btn>

        <v-dialog width="800" v-model="dialog">
          <v-card class="pa-4">
            <h3 class="mt-3 pb-1">Filter Channels</h3>
            <v-layout row wrap>
              <v-flex xs4 v-for="channel in botChannels" :key="channel._id">
                <div class="d-flex align-center justify-center">
                  <v-checkbox
                    class="custom-chat-checkbox"
                    color="#3dd598"
                    v-model="selectedFilterChannels"
                    :value="channel._id"
                    :id="channel._id"
                  ></v-checkbox>
                  <label class="custom-chat-label" :for="channel._id">
                  <span>
                    <supported-platforms
                      class = "supported-platforms-list"
                      :placeholder = "null"
                      :manual-channels = "getManualChannels(channel)"  />
                  </span>
                    {{channel.name}}
                  </label>
                </div>

              </v-flex>
            </v-layout>
            <h3 class="mt-3 pb-1">Conversation State</h3>
            <v-layout row wrap>
              <v-flex xs4>
                <v-checkbox
                  color="#3dd598"
                  v-model="selectedFilterStates"
                  label="Active"
                  :value="true"
                ></v-checkbox>
              </v-flex>
              <v-flex xs4>
                <v-checkbox
                  color="#3dd598"
                  v-model="selectedFilterStates"
                  label="Expired"
                  :value="false"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <h3 class="mt-3 pb-2">User Attributes</h3>
            <v-layout row wrap v-for="(item,index) in userAttributesFilter" class="delete-wrapper">
              <v-flex xs6>
                <v-text-field
                  outline
                  placeholder="Key"
                  v-model="item.key"
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  outline
                  placeholder="Value"
                  v-model="item.value"
                  @change="filterByAttributes"
                />
              </v-flex>
              <v-btn
                fab
                small
                color=""
                class="delete-button"
                @click="deleteAttribute(index)"
              ><v-icon
                small
                color="#666">delete_outline</v-icon></v-btn>
            </v-layout>
            <v-btn
              large round flat block
              class="primary--text"
              @click="addUserAttributeFilter"
            >
              <v-icon>add_circle_outline</v-icon>
              Add Attribute
            </v-btn>
          </v-card>
        </v-dialog>


      </div>
      <!--
        v-infinite-scroll="scrollToMoreSessions"
        infinite-scroll-disabled="busy"
        infinite-scroll-distance="0"
      -->
      <div
        class="side-sessions-wrapper"
        v-infinite-scroll="scrollToMoreSessions"
        infinite-scroll-disabled="busy"
        infinite-scroll-distance="0"
        infinite-scroll-immediate-check="false"
      >
        <chat-session
          v-for="(session, index) in chatSessions"
          :key="index"
          :currentSession="currentSessionId"
          :sessionData="session"
          v-on:sessionSelected="loadSessionHistory"
        />
      </div>
    </section>
    <section class="chat-history">
      <div class="chat-history--header">
        <h2>Chat History</h2>
      </div>

      <!-- v-if="sessionHistory.length" -->
      <div
        class="chat-history--wrapper"
        v-infinite-scroll="scrollToMoreMsgs"
        infinite-scroll-disabled="busy2"
        infinite-scroll-distance="0"
        infinite-scroll-immediate-check="false"
      >
        <chat-history :chatData="sessionHistory" :chatAttrs="sessionAttrs" />
      </div>
    </section>
  </div>
</template>
<script>
import ChatSession from "../components/chat-history/chat-session";
import ChatHistory from "../components/chat-history/chat-history";
import infiniteScroll from "vue-infinite-scroll";
import SupportedPlatforms from '../components/block-build/blocks/SupportedPlatforms.vue'
import axios from "axios";
export default {
  components: { ChatSession, ChatHistory, SupportedPlatforms },
  props: [],
  directives: { infiniteScroll },
  data() {
    return {
      search: null,
      menu: false,
      busy: false,
      busy2: false,
      currentSessionId: null,
      currentSessionsPage: 1,
      currentMsgsPage: 1,
      sessionsHasNext: null,
      msgsHasNext: null,
      chatSessions: [],
      botChannels: [],
      sessionHistory: [],
      sessionAttrs: null,
      selectedFilterChannels: [],
      selectedFilterStates: [],
      channelsStr: "",
      statesStr: "",
      dialog: false,
      userAttributesFilter: [],
      attributesStr: ''
    };
  },
  computed: {
    botId() {
      return localStorage.getItem("botId");
    }
  },
  created() {
    const channelsResquest = this.$http_chat.get("/channels");
    const sessionsRequest = this.loadSessionsByQueries(
      this.currentSessionsPage
    );
    //getting intial session load and bot channels
    this.$store.dispatch("setLoader", true);
    axios
      .all([channelsResquest, sessionsRequest])
      .then(
        axios.spread((...responses) => {
          const channelsResponse = responses[0].data;
          const sessionsResponse = responses[1].data;
          this.botChannels = [...channelsResponse.channels];
          this.chatSessions = [...sessionsResponse.sessions];
          this.currentSessionId = this.chatSessions[0]._id;
          this.loadSessionHistory({ id: this.currentSessionId });
          this.$store.dispatch("setLoader", false);
        })
      )
      .catch(errors => {
        // console.log(errors, " promise all error response");
        this.$store.dispatch("setLoader", false);
      });
  },
  mounted() {
    this.getExternalFilters()
  },
  methods: {
    loadSessionsByQueries(
      page,
      attributes= null,
      channels = null,
      status = null,
      keyword = null
    ) {
      const qrsObj = this.formulateSessionsReqQueries(
        page,
        attributes,
        channels,
        status,
        keyword
      );
      return this.$http_chat.get("/sessions", {
        params: {
          // "filter[bot]": "eyh02tqyi08rj2x0b1w",
          "filter[bot]": this.botId,
          per_page: 15,
          ...qrsObj
        }
      });
    },
    formulateSessionsReqQueries(
      page,
      attributes = null,
      status = null,
      channels = null,
      keyword = null
    ) {
      const obj = {
        page,
        ...attributes,
        ...(status && { "filter[status]": status }),
        ...(channels && { "filter[channel]": channels }),
        ...(keyword && { "query[$or][0][gateway_session_id]": keyword }),
        ...(keyword && { "query[$or][1][_id]": keyword })
      };
      return obj;
    },
    loadSessionHistory(sessionData) {
      this.currentSessionId = sessionData.id;
      this.currentMsgsPage = 1;
      // sessionData.attrs
      //   ? (this.sessionAttrs = sessionData.attrs)
      //   : (this.sessionAttrs = null);
      // this.$store.dispatch("setLoader", true);
      this.$http_chat
        .get(
          `/messages/session/${sessionData.id}?per_page=10&page=${this.currentMsgsPage}`
        )
        .then(({ data: data }) => {
          // console.log(sessionData, " loadSessionHistory");
          this.msgsHasNext = data.data.hasNext;
          this.sessionHistory = [...data.data.messages];
          this.$store.dispatch("setLoader", false);
          this.getSessionAttributes(sessionData.id)
        });
    },
    getSessionAttributes(sessionId) {
      const gatewaySession = this.chatSessions.filter(s => s._id === sessionId)[0].gateway_session_id
      this.$http_chat({
        method: 'get',
        url: '/sessions/attributes',
        params: { gateway_session_id: gatewaySession, bot_id: this.$store.state.bot.botId }
      }).then(res =>{
        // console.log('session attrs', res.data)
        this.sessionAttrs = res.data.data
      })
    },
    scrollToMoreSessions() {
      // this.busy = true;
      this.currentSessionsPage++;
      // this.$store.dispatch('setLoader',true)
      this.loadSessionsByQueries(
        this.currentSessionsPage,
        this.statesStr.replace(/,\s*$/, ""),
        this.channelsStr.replace(/,\s*$/, ""),
        this.search ? this.search : null
      ).then(({ data: data }) => {
        this.chatSessions.push(...data.sessions);
        //need to stop requesting once the response is empty []
        data.sessions.length ? (this.busy = false) : (this.busy = true);
        // this.$store.dispatch('setLoader',false)
      });
    },
    scrollToMoreMsgs() {
      if (this.msgsHasNext) {
        this.currentMsgsPage++;
        this.$http_chat
          .get(
            `/messages/session/${this.currentSessionId}?per_page=10&page=${this.currentMsgsPage}`
          )
          .then(({ data: data }) => {
            this.msgsHasNext = data.data.hasNext;
            this.sessionHistory.push([...data.data.messages]);

            // console.log(data, " scrollToMoreMsgs");
          });
      }
    },
    getManualChannels(channel) {
      const arr = []
      arr.push(channel.name.toLowerCase())
      return arr
    },
    applySearch(keyword) {
      // console.log(keyword, " search");
      this.loadSessionsByQueries(
        1,
        this.attributesStr,
        this.statesStr.replace(/,\s*$/, ""),
        this.channelsStr.replace(/,\s*$/, ""),
        keyword
      ).then(({ data: data }) => {
        // console.log(data, "states filter");
        this.chatSessions = [...data.sessions];
        this.chatSessions.length
          ? (this.currentSessionId = this.chatSessions[0]._id)
          : (this.currentSessionId = null);
        this.chatSessions.length
          ? this.loadSessionHistory({ id: this.currentSessionId, attrs:this.chatSessions[0].attributes })
          : null;
      });
    },
    addUserAttributeFilter () {
      this.userAttributesFilter.push({
        key: '',
        value: ''
      })
    },
    deleteAttribute(index) {
      this.userAttributesFilter.splice(index, 1)
    },
    getExternalFilters() {


      for (let key in this.$route.query) {
        if (this.$route.query.hasOwnProperty(key)) {
          this.userAttributesFilter.push({
            key: key,
            value: this.$route.query[key]
          })
        }
      }

      if (this.userAttributesFilter.length) {
        setTimeout(()=>{
          this.filterByAttributes()
        },1000)

      }
    },
    filterByAttributes() {
      this.attributesStr = {}
      for (let i=0; i<this.userAttributesFilter.length;i++) {
        if (this.userAttributesFilter[i].key && this.userAttributesFilter[i].value && this.userAttributesFilter[i].key !=='session_id') {
          this.attributesStr[`attributes[${this.userAttributesFilter[i].key}]`] = this.userAttributesFilter[i].value
        } else if (this.userAttributesFilter[i].key && this.userAttributesFilter[i].value && this.userAttributesFilter[i].key ==='session_id')  {
          this.attributesStr[`filter[_id]`] = this.userAttributesFilter[i].value
        }
      }
      this.loadSessionsByQueries(
        1,
        this.attributesStr,
        this.statesStr.replace(/,\s*$/, ""),
        this.channelsStr.replace(/,\s*$/, "")
      ).then(({ data: data }) => {
        // console.log(data, "states filter");
        this.chatSessions = []
        this.chatSessions = [...data.sessions];
        this.chatSessions.length
          ? (this.currentSessionId = this.chatSessions[0]._id)
          : (this.currentSessionId = null);
        this.chatSessions.length
          ? this.loadSessionHistory({ id: this.currentSessionId, attrs:this.chatSessions[0].attributes })
          : null;
      });
    }
  },
  watch: {
    selectedFilterChannels(val) {
      // console.log(this.$refs.search.value);
      this.channelsStr = "";
      val.forEach(ch => {
        this.channelsStr += `${ch},`;
      });
      /* ------------------------------ */
      this.loadSessionsByQueries(
        1,
        this.attributesStr,
        this.statesStr.replace(/,\s*$/, ""),
        this.channelsStr.replace(/,\s*$/, "")
      ).then(({ data: data }) => {
        // console.log(data, "states filter");
        this.chatSessions = []
        this.chatSessions = [...data.sessions];
        this.chatSessions.length
          ? (this.currentSessionId = this.chatSessions[0]._id)
          : (this.currentSessionId = null);
        this.chatSessions.length
          ? this.loadSessionHistory({ id: this.currentSessionId, attrs:this.chatSessions[0].attributes })
          : null;
      });
    },
    selectedFilterStates(val) {
      this.statesStr = "";
      val.forEach(ch => {
        this.statesStr += `${ch},`;
      });
      /* ------------------------------ */
      this.loadSessionsByQueries(
        1,
        this.attributesStr,
        this.statesStr.replace(/,\s*$/, ""),
        this.channelsStr.replace(/,\s*$/, "")
      ).then(({ data: data }) => {
        // console.log(data, "states filter");
        this.chatSessions = []
        this.chatSessions = [...data.sessions];
        this.chatSessions.length
          ? (this.currentSessionId = this.chatSessions[0]._id)
          : (this.currentSessionId = null);
        this.chatSessions.length
          ? this.loadSessionHistory({ id: this.currentSessionId, attrs:this.chatSessions[0].attributes })
          : null;
      });
    },
    search(val) {
      val && val.length >= 3 && this.applySearch(val);
      if (!val) {
        this.applySearch(null);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.chat-history-page {
  width: 100%;
  display: flex;
  align-items: flex-start;
}
.side-sessions {
  width: 35%;
  max-width: 450px;
  background-color: #fff;
  height: calc(100vh - 70px);

  &--search {
    height: 80px;
    padding: 20px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e2e2ea;
  }
  &-wrapper {
    height: calc(100% - 80px);
    overflow-y: auto;
  }
}

.filters-dropdown {
  border-radius: 10px;
}

.chat-history {
  padding: 30px 20px;
  flex: 1;
  &--header {
    margin-bottom: 25px;
    h2 {
      font-size: 24px;
    }
  }
  &--wrapper {
    height: calc(100vh - 200px);
    overflow-y: auto;
    border-radius: 8px;
    background-color: #ffffff;
  }
}
.filter-trigger {
  min-width: 40px !important;
  width: 40px;
  border: 1px solid #e6e6e6 !important;
  color: rgba(0, 0, 0, 0.51);
}
.custom-chat-checkbox {
  flex: unset !important;
}
.custom-chat-label {
  img {
    vertical-align: middle;
    margin-right: 5px;
  }
}
.platform-wrapper {
  border-radius: 50%;
  padding: 6px;
  margin-right: 6px;
}
.supported-platforms-list {
    display: inline-flex;
    width: 30px;
    padding: 0;
    margin-top: 20px;
}
</style>
